import { Action, createReducer, on } from '@ngrx/store';
import { addPestampData, addPestampDataFailure, addPestampDataSuccess, cancelPestampRecord, cancelPestampRecordFailure, cancelPestampRecordSuccess, clearPestampData, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createPestampCommentRecord, createPestampCommentRecordSuccess, createRevisionRecord, createRevisionRecordSuccess, editPestampData, editPestampDataFailure, editPestampDataSuccess, fetchPestampAttachments, fetchPestampAttachmentsFailure, fetchPestampAttachmentsSuccess, fetchPestampCancelReasonsList, fetchPestampCancelReasonsListSuccess, fetchPestampMembersList, fetchPestampMembersListSuccess, fetchPestampRecordComments, fetchPestampRecordCommentsFailure, fetchPestampRecordCommentsSuccess, fetchPestampRecordRevisions, fetchPestampRecordRevisionsFailure, fetchPestampRecordRevisionsSuccess, fetchPestampRecordholdunhold, fetchPestampRecordholdunholdFailure, fetchPestampRecordholdunholdSuccess, fetchPestampsListData, fetchPestampsListFailure, fetchPestampsListSuccess, fetchSinglePestampRecordData, fetchSinglePestampRecordDataFailure, fetchSinglePestampRecordDataSuccess, updatePestampStatus, updatePestampStatusFailure, updatePestampStatusSuccess } from "./pestamp.actions";
import { PestampModel } from '../../core/models/pestamp.models';
import { TimelineModel } from '../../core/models/timeline.models';
import { CommentModel } from '../../core/models/comments.models';
import { RevisionModel } from '../../core/models/revisions.models';
import { HoldModel } from '../../core/models/hold.model';
import { ProjectTeamModel } from '../../core/models/projectteam.model';

export interface PestampState {
    tabid: number;
    pestamps: PestampModel[];
    loading: boolean;
    error: any;
    isadded: boolean;
    timelines: TimelineModel[];
    pestamprecord: any;
    comments: CommentModel[];
    revisions: RevisionModel[];
    holdunhold: HoldModel[];
    teammembers: ProjectTeamModel[];
    jobcancelreasons: any;
    attachments: any[]
}

export const initialState: PestampState = {
    tabid: 1,
    pestamps: [],
    loading: true,
    error: null,
    isadded: false,
    timelines: [],
    pestamprecord: null,
    comments: [],
    revisions: [],
    holdunhold: [],
    teammembers: [],
    jobcancelreasons: null,
    attachments: []
};

export const PestampReducer = createReducer(
    initialState,

    // Plan Set Vendor
    on(fetchPestampsListData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchPestampsListSuccess, (state, { Pestamps: pestamps, tabid: tabid }) => {
        return { ...state, pestamps, loading: false, tabid: tabid };
    }),
    on(fetchPestampsListFailure, (state, { error, tabid: tabid }) => {
        return { ...state, error, loading: false, tabid: tabid };
    }),

     // Add Plan Set
     on(addPestampData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(addPestampDataSuccess, (state) => {
        return { ...state, isadded: true, loading: false };
    }),
    on(addPestampDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),

    // fetch Plan Set
    on(fetchSinglePestampRecordData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchSinglePestampRecordDataSuccess, (state, { pestamprecord: pestamprecord }) => {
        return { ...state, isadded: true, loading: false, pestamprecord };
    }),
    on(fetchSinglePestampRecordDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),
    on(clearPestampData, () => {
        return { ...initialState };
    }),

    // Put Plan Set
    on(updatePestampStatus, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(updatePestampStatusSuccess, (state) => {
        return { ...state, loading: false, isadded: true };
    }),
    on(updatePestampStatusFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Comments
    on(fetchPestampRecordComments, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchPestampRecordCommentsSuccess, (state, { comments: comments }) => {
        return { ...state, loading: false, comments };
    }),
    on(fetchPestampRecordCommentsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Revisions
    on(fetchPestampRecordRevisions, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchPestampRecordRevisionsSuccess, (state, { revisions: revisions }) => {
        return { ...state, loading: false, revisions };
    }),
    on(fetchPestampRecordRevisionsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Hold/Unhold Records
    on(fetchPestampRecordholdunhold, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchPestampRecordholdunholdSuccess, (state, { holdunhold: holdunhold }) => {
        return { ...state, loading: false, holdunhold };
    }),
    on(fetchPestampRecordholdunholdFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

     // PUT REQUEST ON HOLD
     on(createHoldRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createHoldRecordSuccess, (state, { holdrecord }) => {
        return { ...state, loading: false, error: null, holdunhold: holdrecord };
    }),

    // PUT REQUEST REVISION
    on(createRevisionRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createRevisionRecordSuccess, (state) => {
        return { ...state, loading: false, error: null };
    }),

    // CREATE PESTAMP COMMENT RECORD
    on(createPestampCommentRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createPestampCommentRecordSuccess, (state, { comment }) => {
        return { ...state, loading: false, error: null, comments: comment };
    }),

    // CREATE PESTAMP COMMENT RECORD
    on(fetchPestampMembersList, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(fetchPestampMembersListSuccess, (state, { memberslist }) => {
        return { ...state, loading: false, error: null, teammembers: memberslist };
    }),

    // FETCH JOB CANCEL REASONS
    on(fetchPestampCancelReasonsList, (state) => {
        return { ...state, error: null};
    }),
    on(fetchPestampCancelReasonsListSuccess, (state, { reasons }) => {
        return { ...state, error: null, jobcancelreasons: reasons };
    }),
    // CANCEL PESTAMP RECORD
    on(cancelPestampRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(cancelPestampRecordSuccess, (state) => {
        return { ...state, loading: false };
    }),
    on(cancelPestampRecordFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // PESTAMP ATTACHMENTS
    on(fetchPestampAttachments, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchPestampAttachmentsSuccess, (state, { attachments}) => {
        return { ...state, loading: false, attachments};
    }),
    on(fetchPestampAttachmentsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

     // Edit Plan Set
     on(editPestampData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(editPestampDataSuccess, (state) => {
        return { ...state, isadded: true, loading: false };
    }),
    on(editPestampDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),
);

// Selector
export function reducer(state: PestampState | undefined, action: Action) {
    return PestampReducer(state, action);
}
